export const GET_SMS = 'GET_SMS';

// Store

export interface StateSms {
    sms: object;
    smsPageCurrent: null;
    smsPageCount: null;
}
